import React from 'react';

const ArrowInTable: React.FC = () => {

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66602 3.33203L13.3327 9.9987" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M6.66602 16.668L13.3327 10.0013" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    );
};

export default ArrowInTable;